/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import dynamicComponent from '../../dynamicComponent';
const AccessDenied = dynamicComponent(() => import(/* webpackChunkName: "AccessDenied" */ './accessDenied'));
export default AccessDenied;
